var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"dense":"","justify":"space-between"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('EscolhaOpcaoSelect',{attrs:{"inscricao":_vm.inscricao,"opcoes":_vm.opcoes}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }